export const SessionTypes = {
  defaultType: "A",
  testUserType: "B",
};
